import React, { useState, useEffect } from "react";
import "./winnerPicker.scss";
import { useParams } from "react-router-dom";
import axios from "axios";
import bg from "../../img/bgg.jpg";

const WinnerPicker = () => {
  const { eventName } = useParams();
  const decodedEventName = decodeURIComponent(eventName);
  const [contestants, setContestants] = useState("");
  const [winnerCount, setWinnerCount] = useState(1);
  const [winners, setWinners] = useState([]);
  const [isCounting, setIsCounting] = useState(false);
  const [timer, setTimer] = useState(10);
  const [showResults, setShowResults] = useState(false);
  const [loading, setLoading] = useState(false); // Used for API fetch state

  /* =========================
     Fetch Winners from API
     ========================= */
  useEffect(() => {
    const getWinners = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`/get-winners/:eventName`, {
          params: { eventName: decodedEventName },
        });

        const contestantsList = response.data.map(
          (item) =>
            `${item.email || "No Email"} - ${item.contact || "No Contact"}`,
        );

        // Convert array to string with new lines for the textarea
        setContestants(contestantsList.join("\n"));
      } catch (error) {
        console.error("Failed to fetch participants", error);
      } finally {
        setLoading(false);
      }
    };

    if (eventName) getWinners();
  }, [eventName]);


  console.log(winners);

  useEffect(() => {
    if (!winners || winners.length === 0) return;

    const saveWinners = async () => {
      try {
        for (const winner of winners) {
          // winner is a string like "alirobad@gmail.com - +971503134905"
          const email = winner.split(" - ")[0]; // take only email

          await axios.post("/save-winners", {
            winner: true,
            email: email,
          });
        }
        console.log("Winners saved successfully!");
      } catch (error) {
        console.error("Error saving winners:", error);
      }
    };

    saveWinners();
  }, [winners]);

  /* =========================
     Countdown Logic
     ========================= */
  useEffect(() => {
    let interval = null;
    if (isCounting && timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0 && isCounting) {
      const list = contestants
        .split("\n")
        .map((item) => item.trim())
        .filter((item) => item !== "");

      const shuffled = [...list].sort(() => 0.5 - Math.random());
      const selected = shuffled.slice(0, Math.min(winnerCount, list.length));

      setWinners(selected);
      setIsCounting(false);
      setShowResults(true);
    }
    return () => clearInterval(interval);
  }, [isCounting, timer, contestants, winnerCount]);

  const handleStartDraw = () => {
    const list = contestants.split("\n").filter((t) => t.trim() !== "");
    if (list.length === 0) return alert("Please enter contestants first.");

    setTimer(10);
    setIsCounting(true);
  };

  return (
    <div
      className="dubai-theme-wrapper"
      style={{
        backgroundImage: `linear-gradient(90deg, rgba(2, 0, 36, 0.65) 0%, rgba(9, 9, 121, 0.4) 35%, rgba(0, 212, 255, 0) 100%), url(${bg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* 1. THE MAIN PORTAL (Stays visible in background) */}
      <div className="glass-card">
        <div className="badge">Special Activation</div>

        <header className="picker-header">
          <h1>Winner Selection Portal</h1>
          <p style={{ textTransform: "capitalize" }}>
            {eventName?.replace(/-/g, " ")}
          </p>
        </header>

        {/* Keep the list visible during countdown by checking showResults only */}
        {!showResults ? (
          <div className="form-content">
            <div className="input-field">
              <label>Participant List</label>
              <textarea
                placeholder={loading ? "Loading..." : "Enter entries..."}
                value={contestants}
                disabled={isCounting || loading}
                onChange={(e) => setContestants(e.target.value)}
              />
              <span className="count-hint">
                {loading
                  ? "Syncing..."
                  : `${contestants.split("\n").filter((t) => t).length} Entries Detected`}
              </span>
            </div>

            <div className="controls">
              <div className="count-input">
                <small>Winners</small>
                <input
                  type="number"
                  value={winnerCount}
                  onChange={(e) => setWinnerCount(e.target.value)}
                  disabled={isCounting}
                />
              </div>
              <button
                className="draw-btn"
                onClick={handleStartDraw}
                disabled={isCounting || loading || !contestants}
              >
                {isCounting ? "Drawing..." : "Draw Winners"}
              </button>
            </div>
          </div>
        ) : (
          /* Winner Results Section */
          <div className="results-content animate-pop">
            <div className="winner-podium">
              <div className="icon-wrap">
                <img src={require("../../img/party.gif")} alt="" />
              </div>
              <h2>Official Results</h2>
              <div className="winner-scroll">
                {winners.map((name, i) => (
                  <div key={i} className="winner-row">
                    <span className="rank">#{i + 1}</span>
                    <span className="__name">{name}</span>
                  </div>
                ))}
              </div>
              <button
                className="reset-link"
                onClick={() => setShowResults(false)}
              >
                ← Start New Draw
              </button>
            </div>
          </div>
        )}
      </div>

      {/* 2. THE BIG COUNTDOWN OVERLAY */}
      {/* This will pop up ON TOP of the list when isCounting is true */}
      {isCounting && (
        <div
          className="fullscreen-overlay"
          style={{
            backgroundImage: `linear-gradient(90deg, rgba(2, 0, 36, 0.65) 0%, rgba(9, 9, 121, 0.4) 35%, rgba(0, 212, 255, 0) 100%), url(${bg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="main_bg">
            <div className="activation-label">{eventName}</div>
            <div className="number" id="big-number">
              {timer}
            </div>
            <div className="entries-count-overlay">
              <h5>
                Processing {contestants.split("\n").filter((t) => t).length}{" "}
                Participants...
              </h5>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WinnerPicker;
